import React, { useEffect } from "react";
import { Prompt } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CheckChangesWithoutSaving = ({ isDisabledInputs }) => {
  const [t] = useTranslation("global");

  useEffect(() => {
    const alertLeavePrescriptionsWithoutSaving = (e) => {
      e.preventDefault();
      e.returnValue = t("prescriptions.beforeLeavingMessage");
    };
    if (!isDisabledInputs) {
      window.addEventListener("beforeunload", alertLeavePrescriptionsWithoutSaving);
      return () => {
        window.removeEventListener("beforeunload", alertLeavePrescriptionsWithoutSaving);
      };
    }
  }, [isDisabledInputs, t]);

  return <Prompt when={!isDisabledInputs} message={t("prescriptions.beforeLeavingMessage")} />;
};

export default CheckChangesWithoutSaving;
